// themeConfig.js
// Theme configuration file for easy switching between different themes
// Simply change the CURRENT_THEME constant to switch themes

import defaultTheme from './defaultTheme';
import orangeTheme from './orangeTheme';

// Available themes
export const THEMES = {
  DEFAULT: 'default',
  ORANGE: 'orange',
};

// Change this constant to switch themes
export const CURRENT_THEME = THEMES.ORANGE; // Switch to THEMES.DEFAULT to use the original theme

// Theme mapping
const themeMap = {
  [THEMES.DEFAULT]: defaultTheme,
  [THEMES.ORANGE]: orangeTheme,
};

// Export the current theme
export const currentTheme = themeMap[CURRENT_THEME];

export default currentTheme;
